import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';

export default function CategoryStrip() {
  const list = categories.filter((c) => c.key !== 'all');

  return (
    <section id="categories" className="px-4 md:px-10 py-16 md:py-20 bg-background-100 border-y border-background-200" aria-label="主题分类">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <span className="text-xs tracking-[0.3em] text-primary-600 font-medium">CATEGORIES</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">按主题分类浏览</h2>
        </div>
        <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
          每个分类都收录了同一类的合集与盘点，点进去就能看到该分类下所有上线中的专题。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {list.map((cat, idx) => (
          <Link
            key={cat.key}
            to={`/topics?cat=${cat.key}`}
            className={`group rounded-lg border p-5 flex flex-col justify-between min-h-[150px] transition-colors cursor-pointer ${
              idx === 0
                ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 border-background-200 hover:border-primary-300'
            }`}
          >
            <span
              className={`w-10 h-10 rounded-md flex items-center justify-center text-xl ${
                idx === 0 ? 'bg-background-50/20 text-background-50' : 'bg-accent-100 text-accent-800'
              }`}
            >
              <i className={cat.icon}></i>
            </span>
            <div>
              <h3 className={`font-heading text-lg font-bold ${idx === 0 ? 'text-background-50' : 'text-foreground-950'}`}>
                {cat.name}
              </h3>
              <p className={`mt-2 text-xs leading-relaxed ${idx === 0 ? 'text-primary-100' : 'text-foreground-600'}`}>
                {cat.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}